import React from "react";
import { Box } from "@mui/material";
import { H6, Loading } from "components";

export const CommonQuicksightDashboard = ({
    embedUrl,
    isLoading,
    title,
}: {
    embedUrl: string;
    isLoading: boolean;
    title: string;
}) => {
  if (isLoading) {
    return <Loading />;
  }

  if (!embedUrl) {
    return <Box sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      py: 3,
    }}>
      <H6>No {title} URL found</H6>
    </Box>;
  }

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "calc(100vh - 200px)",
      minHeight: "calc(100vh - 200px)",
      py: 3,
      pr: 3,
      overflow: "hidden",
    }}>
      <Box sx={{ flex: 1, minHeight: 0, display: "flex" }}>
        <iframe
          src={embedUrl}
          title={title}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      </Box>
    </Box>
  );
}
